var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1642_6328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 90C72.0914 90 90 72.0914 90 50C90 27.9086 72.0914 10 50 10C27.9086 10 10 27.9086 10 50C10 72.0914 27.9086 90 50 90Z",
    fill: "#BF0505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 99C77.062 99 99 77.062 99 50C99 22.938 77.062 1 50 1C22.938 1 1 22.938 1 50C1 77.062 22.938 99 50 99Z",
    stroke: "#BF0505",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1153 50.0003L66.3545 36.7607C67.2161 35.8995 67.2161 34.5071 66.3545 33.6459C65.4933 32.7847 64.1009 32.7847 63.2397 33.6459L50.0002 46.8855L36.761 33.6459C35.8994 32.7847 34.5074 32.7847 33.6462 33.6459C32.7846 34.5071 32.7846 35.8995 33.6462 36.7607L46.8854 50.0003L33.6462 63.2398C32.7846 64.101 32.7846 65.4934 33.6462 66.3546C34.0754 66.7842 34.6397 67 35.2036 67C35.7675 67 36.3314 66.7842 36.761 66.3546L50.0002 53.115L63.2397 66.3546C63.6693 66.7842 64.2332 67 64.7971 67C65.361 67 65.9249 66.7842 66.3545 66.3546C67.2161 65.4934 67.2161 64.101 66.3545 63.2398L53.1153 50.0003Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1642_6328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRedIcon);
export default __webpack_public_path__ + "static/media/cross-red-icon.71dce4c39c7d1d03ac31a7bfd88a9efe.svg";
export { ForwardRef as ReactComponent };